import { currentTime } from '../helpers/time';

export default class JobModel {
  constructor(data) {
    data.attributes.start_date = currentTime(data.attributes.start_date);
    data.attributes.end_date = currentTime(data.attributes.end_date);
    Object.assign(this, data);
  }
}